import React from "react";
import PropTypes from "prop-types";
import {
  FormModalWrapper,
  FormModalContainer,
  FormModalHeader,
  FormModalTitle,
  FormModalCloseButton,
  FormModalContent,
} from "./CustomModalStyles";
import Text from "../Common/Text";
import Colors from "../../themes/Colors";

const FormModal = ({ isOpen, onClose, title, children, showCloseButton }) => {
  if (!isOpen) {
    return null;
  }

  const handleWrapperClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <FormModalWrapper onClick={handleWrapperClick}>
      <FormModalContainer onClick={(e) => e.stopPropagation()}>
        <FormModalHeader>
          <FormModalTitle>
            <Text
              size="22px"
              weight="bold"
              color={Colors.darkGreenPrimera}
              textAlign="center"
              margin="0"
            >
              {title}
            </Text>
          </FormModalTitle>
          {showCloseButton && (
            <FormModalCloseButton onClick={onClose}>×</FormModalCloseButton>
          )}
        </FormModalHeader>

        <FormModalContent>{children}</FormModalContent>
      </FormModalContainer>
    </FormModalWrapper>
  );
};

FormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showCloseButton: PropTypes.bool,
};

FormModal.defaultProps = {
  showCloseButton: true,
};

export default FormModal;
